import React, {useEffect, useRef, useState} from 'react';
import axios from '../../services/axiosInstance';
import '../../css/web/AdminFullTransferPg.css';

import maCateImg from "../../assets/img/m-a-cate.png";
import {useWebSocket} from "../../services/WebsocketContext";
import MsgCheckModal from "../../components/web/modal/MsgCheckModal";

function AdminFullTransferPg() {

    const SSAT = sessionStorage.getItem('adminToken');
    const LCAT = localStorage.getItem('adminToken');

    const [adminInfo, setAdminInfo] = useState([]);

    const selectAdminInfo = (() => {
        axios({
            method: 'get',
            url: '/member/modiInfo',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response)=> {
                setAdminInfo(response.data[0])
            })
            .catch(()=> {
                console.log("멤버조회 실패")
            })
    })

    useEffect(() => {
        selectAdminInfo();
    }, [])

    const isSubscribedRef = useRef(false);
    const {subscribe, unsubscribe, websocketConnect, isConnected, stompClient} = useWebSocket();

    useEffect(() => {
        const initializeConnection = async () => {
            if (!adminInfo.mbNum || isSubscribedRef.current) return;

            if (!stompClient && !isConnected) {
                await websocketConnect(adminInfo.mbNum);
            }
            if (isConnected && stompClient && !isSubscribedRef.current) {
                isSubscribedRef.current = true;
            }
        }

        initializeConnection();

        return () => {
            if (isSubscribedRef.current) {
                isSubscribedRef.current = false;
            }
        };

    }, [adminInfo.mbNum, isConnected, stompClient]);


    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [inputFieldError, setInputFieldError] = useState(false);
    const [sendBtLoading, setSendBtLoading] = useState(false);
    const [sendBtDisabled, setSendBtDisabled] = useState(false);

    const closeInputFieldError = () => {
        setInputFieldError(false);
    }

    const handleSubmit = () => {
        if (!title.trim() || !content.trim()) {
            setInputFieldError(true);
            return;
        }

        setSendBtLoading(true);
        setSendBtDisabled(true);

        axios({
            method: 'post',
            url: '/member/fullTransferMessage',
            Authorization: LCAT || SSAT,
            data: { // 💡 params 대신 data 사용해야 장문 및 특수문자 전송가능
                title: title,
                content: content
            }
        })
            .then((res) => {
                console.log("전체전송 성공 : ", res);
                clearMessage();
            })
            .catch((err) => {
                console.log("전체전송 실패 : ", err);
                setFailedSend(true);
            })
            .finally(() => {
                setSendBtLoading(false);
                setSendBtDisabled(false);
            })
    };

    const [successSend, setSuccessSend] = useState(false);
    const [failedSend, setFailedSend] = useState(false);

    const closeSuccessSend = () => {
        setSuccessSend(false);
    }

    const closeFailedSend = () => {
        setFailedSend(false);
    }

    const clearMessage = () => {
        setTitle('');
        setContent('');
        setSuccessSend(true);
    }



    return (
        <div className="AdminEmployeeInfoPg font-t-cont">
            <div className="admin-work-title">
                <img className="wd-35 ht-35" alt="" src={maCateImg}/>
                <p className="p-t-6">전체 메일 & 채팅</p>
            </div>

            <div className="admin-wrap">
                <div className="admin-wrap-card full-transfer-card">
                    <div className="full-transfer-inner">
                        <input
                            className="mail-title-input font-s-16"
                            placeholder="제목"
                            value={title}
                            maxLength={80}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                        <textarea
                            className="mail-content-textarea font-s-14"
                            placeholder="내용"
                            value={content}
                            maxLength={10000}
                            onChange={(e) => setContent(e.target.value)}
                        ></textarea>
                        <style>
                            {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                        </style>
                        <button className="send-button user-center" onClick={handleSubmit} disabled={sendBtDisabled}>
                            {sendBtLoading ? (
                                <div className="spinner"></div>
                            ) : (
                                "전체전송"
                            )}
                        </button>
                        <div className="font-s-14">
                            <p className="mb-1" style={{color: "#DB5744"}}>※ 메일은 제목+내용 / 주문서채팅은 내용만 전체 전송됩니다</p>
                            <p style={{color: "#DB5744"}}>※ 제목은 80자, 내용은 10000자까지 입력이 가능합니다</p>
                        </div>
                    </div>
                </div>
            </div>


            {inputFieldError ?
                <MsgCheckModal
                    inputFieldError={inputFieldError}
                    closeInputFieldError={closeInputFieldError}
                />
                :
                successSend ?
                    <MsgCheckModal
                        successSend={successSend}
                        closeSuccessSend={closeSuccessSend}
                    />
                    :
                    failedSend ?
                        <MsgCheckModal
                            failedSend={failedSend}
                            closeFailedSend={closeFailedSend}
                        />
                        :
                null
            }

        </div>
    );
}

export default AdminFullTransferPg
